export default __webpack_public_path__ + "static/media/program-main.6a74d45f.jpg";